import React, { Component } from "react";
import Tribute from "tributejs";

import "./Mention.scss";

class Mention extends Component {
  componentDidMount() {
    this.defaultOptions = {
      lookup: "key",
      fillAttr: "key",
      collection: [],
      positionMenu: false,
      menuContainer: this.menu,
      menuItemTemplate: this.menuItemTemplate,
      noMatchTemplate: this.noMatchTemplate,
    };

    this.handlePaste = this.handlePaste.bind(this);
    this.handleContentChange = this.handleContentChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.isIE = /Trident/.test(navigator.userAgent);
    this.requiresPasteCallback = this.isIE;
    this.eventType = this.isIE ? "keyup" : "input";
    this.node.addEventListener(this.eventType, this.handleContentChange);
    this.node.addEventListener("paste", this.handlePaste);
    this.node.addEventListener("keydown", this.handleKeyDown);
    this.node.addEventListener("click", this.handleClick);
    this.setup();
  }

  componentWillUnmount() {
    this.tribute.detach(this.node);

    if (this.props.onInputChange) {
      this.node.removeEventListener(
        "tribute-replaced",
        this.handleContentChange
      );
    }
    this.node.removeEventListener(this.eventType, this.handleContentChange);
    this.node.removeEventListener("paste", this.handlePaste);
    this.node.removeEventListener("click", this.handleClick);
  }

  setup = () => {
    const options = Object.assign({}, this.defaultOptions, this.props.options);

    this.tribute = new Tribute(options);
    this.tribute.attach(this.node);

    if (this.props.onInputChange) {
      this.node.addEventListener(
        "tribute-replaced",
        this.handleContentChange.bind(this)
      );
    }
    if (this.props.defaultValue && this.props.defaultValue.length > 0) {
      this.insertBlock(this.props.defaultValue);
    }
  };

  handleContentChange = (event) => {
    this.props.onInputChange &&
      this.props.onInputChange(event.target.innerHTML, event.target.innerText);
  };

  handlePaste = (e) => {
    e.preventDefault();
    let text;
    if (e.clipboardData || (e.originalEvent && e.originalEvent.clipboardData)) {
      text = (e.originalEvent || e).clipboardData.getData("text/plain");
    } else if (window.clipboardData) {
      text = window.clipboardData.getData("Text");
    }
    const pasteCommand = this.isIE ? "paste" : "insertHTML";
    document.execCommand(pasteCommand, false, text);
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 38) {
      // up arrow
      let entries = Array.prototype.slice.call(
        this.menu.querySelectorAll("li")
      );
      let highlightedElementIndex = entries.findIndex(
        (elem) => elem.className === "highlight"
      );
      if (entries[highlightedElementIndex]) {
        let newIndex =
          highlightedElementIndex > 0
            ? highlightedElementIndex - 1
            : entries.length - 1;
        let topOffset = entries[newIndex].offsetTop;
        let ul = this.menu.querySelector("ul");
        if (ul) ul.scrollTop = topOffset - 8;
      }
    } else if (e.keyCode === 40) {
      let entries = Array.prototype.slice.call(
        this.menu.querySelectorAll("li")
      );
      let highlightedElementIndex = entries.findIndex(
        (elem) => elem.className === "highlight"
      );
      if (entries[highlightedElementIndex]) {
        let newIndex =
          highlightedElementIndex < entries.length - 1
            ? highlightedElementIndex + 1
            : 0;
        let topOffset = entries[newIndex].offsetTop;
        let ul = this.menu.querySelector("ul");
        if (ul) ul.scrollTop = topOffset - 8;
      }
    }
  };

  handleClick = (e) => {
    if (e.target.tagName === "SPAN") {
      let range = document.createRange();
      let sel = window.getSelection();
      range.setStart(e.target.nextSibling, 0);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
      this.node.focus();
    }
  };

  menuItemTemplate = (item) => {
    return `<div class="list-item"><div class="item">${item.string}</div></div>`;
  };

  noMatchTemplate = () => {
    const noResults = this.props.noResultsText || "Nenhum resultado encontrado";
    return `<div class="no-results">${noResults}</div>`;
  };

  getMenuStyle = () => {
    let topOffset = this.props.suggestionsLength * 50 + 16;
    if (topOffset > 110) topOffset = 110;
    if (topOffset < 55) topOffset = 55;

    return {
      top: topOffset * -1 + "px",
    };
  };

  insertBlock = (block) => {
    this.node.focus();
    this.node.innerHTML +=
      (this.node.textContent.length ? "&nbsp" + block : block) + "&nbsp";
    this.tribute.placeCaretAtEnd(this.node);
    this.requiresPasteCallback &&
      this.props.onInputChange &&
      this.props.onInputChange(this.node.textContent);
  };

  insertTextAtEnd = (text) => {
    this.node.innerHTML += text;
    this.tribute.placeCaretAtEnd(this.node);
  };

  clear = () => {
    this.node.focus();
    this.node.innerHTML = "";
  };

  getMentions = () => {
    let mentions = Array.prototype.slice.call(
      this.node.querySelectorAll(".mention-user")
    );
    return mentions.map((elem) => elem.dataset.user);
  };

  setFocus = () => {
    this.node.focus();
  };

  render() {
    const { className, inputType, dropdownClass, placeholder } = this.props;

    return (
      <div className={`mention ${className ? className : ""}`}>
        <div
          ref={(node) => (this.node = node)}
          className={`input ${inputType ? inputType : "single-line"}`}
          placeholder={placeholder || ""}
        ></div>
        <div
          ref={(menu) => (this.menu = menu)}
          className={`menu ${dropdownClass || ""}`}
          style={this.getMenuStyle()}
        ></div>
      </div>
    );
  }
}

export default Mention;
